<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.49992 14.9997L11.9106 10.589C12.2361 10.2636 12.2361 9.73598 11.9106 9.41055L7.49992 4.99985" stroke="#1B60CA" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
